import {
    SUCCESS_GET_PROGRESS,
    FAILED_GET_PROGRESS,
} from '../constants/pollConstants';

const defaultState = {
    pollData: null,
};

export const pollReducer = (state = defaultState, {type, payload, errorMessage}) => {
    switch (type) {
        case SUCCESS_GET_PROGRESS:
            return {
                ...state,
                pollData: payload.result,
            };
        case FAILED_GET_PROGRESS:
            return {
                ...state,
                errorMessage: errorMessage
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/reducers/pollReducer.js